import React from "react";
import { Link } from "react-router-dom";
import { products } from "../mock";
import { Button } from "./ui/button";
import { ArrowRight } from "lucide-react";

export default function ProductsGrid({ title = true }) {
  return (
    <section className="bg-white py-16 md:py-24">
      <div className="max-w-7xl mx-auto px-6">
        {title && (
          <div className="text-center mb-12">
            <p className="text-[11px] tracking-[0.3em] text-orange-600 font-semibold uppercase">Featured</p>
            <h2 className="font-display text-3xl md:text-5xl font-bold mt-3 uppercase">Our Products</h2>
            <span className="block w-24 h-[3px] bg-orange-500 mx-auto mt-4" />
          </div>
        )}
        <div className="grid sm:grid-cols-2 gap-6 md:gap-8 max-w-4xl mx-auto">
          {products.map(p => (
            <Link to={`/products/${p.slug}`} key={p.slug} className="group lift-on-hover bg-cream rounded-2xl overflow-hidden border border-orange-100 relative">
              <span className="absolute top-4 right-4 z-10 bg-orange-500 text-white text-[10px] font-bold tracking-widest uppercase px-2.5 py-1 rounded-full">Premium</span>
              <div className="aspect-[4/3] bg-white flex items-center justify-center overflow-hidden">
                <img src={p.image} alt={p.name} className="w-full h-full object-contain group-hover:scale-105 transition-transform duration-500" />
              </div>
              <div className="p-5 text-center">
                <h3 className="font-display text-lg md:text-xl uppercase text-neutral-900">{p.name}</h3>
                <span className="block w-10 h-[3px] bg-orange-500 mx-auto mt-3 group-hover:w-16 transition-all" />
              </div>
            </Link>
          ))}
        </div>
        <div className="mt-12 text-center">
          <Link to="/products">
            <Button className="bg-orange-500 hover:bg-orange-600 text-white rounded-full px-7 py-6 uppercase tracking-wider font-semibold">
              View All Products <ArrowRight size={16} className="ml-2" />
            </Button>
          </Link>
        </div>
      </div>
    </section>
  );
}
